import type { DeepThoughtsPrerequisitesStatus } from "@/lib/api/activities";
import { create } from "zustand";

interface DeepThoughtsSendStore {
  isOpen: boolean;
  prereqs: DeepThoughtsPrerequisitesStatus | null;
  openSend: (prereqs?: DeepThoughtsPrerequisitesStatus | null) => void;
  setOpen: (open: boolean) => void;
}

export const useDeepThoughtsSendStore = create<DeepThoughtsSendStore>(
  (set) => ({
    isOpen: false,
    prereqs: null,
    openSend: (prereqs = null) => set({ isOpen: true, prereqs }),
    setOpen: (isOpen) =>
      set((state) => ({
        isOpen,
        prereqs: isOpen ? state.prereqs : null,
      })),
  }),
);
